import Const from './js/const'
import Config from './js/config'
import Util from './js/util'
import Api from './js/api'
import Email from './js/email'
import Data from './js/data'

const Core = {
  Config: Config,
  Const: Const,
  Util: Util,
  Api: Api,
  Data: Data,
  Email: Email
}
export default Core
